import { Column } from './column';
import {
  boardBodyStyle,
  columnContainerStyle
} from './jsw-interactive-board.styles';
import { useInteractiveBoardStore } from './state';
import { Assignee, EpicName, IssueTypeName, Priority } from './constants/ui';
import { useEffect } from 'react';

export const BoardBody = () => {
  const [
    { messages, todoCol, inProgressCol, doneCol },
    { setInProgressCol, setDoneCol }
  ] = useInteractiveBoardStore();

  useEffect(() => {
    void setInProgressCol([
      {
        id: 'inProg1',
        summary: messages.inProgStaticLabel1,
        issueType: IssueTypeName.STORY,
        epicName: EpicName.FEATURES,
        assignee: Assignee.JANE,
        priority: Priority.BLOCKER
      },
      {
        id: 'inProg2',
        summary: messages.inProgStaticLabel2,
        issueType: IssueTypeName.STORY,
        epicName: EpicName.FEATURES,
        assignee: Assignee.BLAKE,
        priority: Priority.HIGH
      }
    ]);

    void setDoneCol([
      {
        id: 'done1',
        summary: messages.doneStaticLabel1,
        issueType: IssueTypeName.BUG,
        epicName: EpicName.FEATURES,
        assignee: Assignee.ALVIN,
        priority: Priority.MINOR
      },
      {
        id: 'done2',
        summary: messages.doneStaticLabel2,
        issueType: IssueTypeName.TASK,
        epicName: EpicName.FEATURES,
        assignee: Assignee.JANE,
        priority: Priority.CRITICAL
      }
    ]);
  }, [messages]);

  return (
    <div css={boardBodyStyle}>
      <div css={columnContainerStyle}>
        <Column title={messages.toDo} cards={todoCol} />
        <Column title={messages.inProgress} cards={inProgressCol} />
        <Column title={messages.done} cards={doneCol} />
      </div>
    </div>
  );
};
